import { NavLink } from "react-router-dom";

const items = [
  { label: "首页", icon: "ri-home-5-line", to: "/" },
  { label: "电影", icon: "ri-film-line", to: "/category/movie" },
  { label: "电视剧", icon: "ri-tv-2-line", to: "/category/drama" },
  { label: "搜索", icon: "ri-search-line", to: "/search" },
];

export default function MobileBottomNav() {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50/95 backdrop-blur border-t border-background-200">
      <div className="grid grid-cols-4">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] transition-colors ${
                isActive ? "text-primary-500" : "text-foreground-500"
              }`
            }
          >
            <i className={`${item.icon} text-xl`}></i>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}